<template>
	<div class="toast-container">
		<div class="toast-message">
			<TransitionGroup name="toast-message" appear>
				<template v-for="toast in toastsList" :key="toast.id">
					<ToastMessage v-bind="toast" />
				</template>
			</TransitionGroup>
		</div>
	</div>
</template>

<script setup>
import ToastMessage from './ToastMessage.vue';
import { Toast } from '@/presentation/helper';
const toastsList = computed(() => Toast.toasts);
</script>

<style lang="scss" scoped>
.toast-container {
	position: fixed;
	z-index: calc(3000 * 4000);
	left: 24px;
	right: auto;
	bottom: 24px;
	display: flex;
	flex-direction: column;
	gap: 6px;
	align-items: flex-start;
	max-width: calc(100vw - 48px);
	pointer-events: none;
}

.toast-message {
	direction: rtl;
	display: flex;
	flex-direction: column;
	gap: 8px;
	align-items: flex-start;
	max-width: 100%;
	pointer-events: auto;

	&-enter-active {
		transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
	}

	&-leave-active {
		transition: all 0.3s ease-in;
	}

	&-enter-from,
	&-leave-to {
		transform: translateY(12px);
		opacity: 0;
	}
}

@media screen and (max-width: 768px) {
	.toast-container {
		left: 16px;
		right: 16px;
		bottom: calc(var(--app-bottom-nav-height, 0px) + 72px);
		align-items: center;
		max-width: calc(100vw - 32px);
	}

	.toast-message {
		align-items: center;
	}
}
</style>
